import {
  Browser,
  DeviceMobile,
  PlugsConnected,
  CloudArrowUp,
  ChatCircleText,
  ShieldCheck,
} from '@phosphor-icons/react';
import '../LandingPage.css';

const services = [
  {
    icon: Browser,
    title: 'Web applications',
    description:
      'Business applications that run in the browser, from internal tools to customer portals. We usually build them with React and TypeScript.',
  },
  {
    icon: DeviceMobile,
    title: 'Screens for every device',
    description:
      'Layouts that work on a phone at a restaurant table as well as on an office monitor.',
  },
  {
    icon: PlugsConnected,
    title: 'APIs and integrations',
    description:
      'Back ends and data models, plus connections to delivery platforms, fiscal printers and the other services your business already uses.',
  },
  {
    icon: CloudArrowUp,
    title: 'Hosting and deployment',
    description:
      'Hosting on Microsoft Azure with automated build and release pipelines, so updates reach production without manual steps.',
  },
  {
    icon: ChatCircleText,
    title: 'AI chat assistants',
    description:
      'Assistants that answer customer questions on your website, like the one in the corner of this page.',
  },
  {
    icon: ShieldCheck,
    title: 'Security and data protection',
    description:
      'Applications designed with GDPR in mind, where each person can reach only the data their job needs.',
  },
];

function ServicesSection() {
  return (
    <section id="services" className="services-section section" aria-labelledby="services-title">
      <div className="section-content">
        <div className="section-head reveal">
          <h2 id="services-title" className="section-title">What we build</h2>
          <p className="section-lead">
            We work on the whole life of an application: planning it, building
            it, putting it into production and looking after it once people
            use it.
          </p>
        </div>

        <div className="services-grid reveal">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <article key={service.title} className="service-card">
                <Icon className="service-card-icon" size={24} aria-hidden="true" />
                <h3 className="service-card-title">{service.title}</h3>
                <p className="service-card-text">{service.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
